import "./digital-assets-continue-shopping-modal-asset-item.scss";

export default class DigitalAssetsContinueShoppingModalAssetItem {
  #lineItemTemplateSelector;

  constructor(
    options = {
      lineItemTemplateSelector: ""
    }
  ) {
    this.#lineItemTemplateSelector = options.lineItemTemplateSelector;
  }

  get $lineItemTemplate() {
    return document.querySelector(this.#lineItemTemplateSelector);
  }

  get $lineItemImage() {
    return this.$lineItemTemplate.querySelector(".js-continue-shopping-modal-image");
  }

  get $lineItemTitle() {
    return this.$lineItemTemplate.querySelector(".js-continue-shopping-modal-title");
  }

  get $lineItemPrice() {
    return this.$lineItemTemplate.querySelector(".js-continue-shopping-modal-price");
  }

  fillLineItem(assetInfo) {
    this.$lineItemImage.src = assetInfo.image;
    this.$lineItemTitle.textContent = assetInfo.title;
    this.$lineItemPrice.textContent = assetInfo.price;
  }
}
